import ReactMarkdown from 'react-markdown';
import rehypeSanitize from 'rehype-sanitize';
import { LandingNav } from '@/components/layout/LandingNav';
import { Footer } from '@/components/layout/Footer';

interface Props { source: string }

/**
 * Markdown pages are sanitized through rehype-sanitize. Script tags, inline event
 * handlers, and `javascript:` URLs are stripped before rendering — the OWASP XSS
 * mitigation for the only `dangerouslySetInnerHTML`-equivalent code path in the app.
 */
export function MarkdownPage({ source }: Props) {
  return (
    <div className="landing-page">
      <LandingNav />
      <article className="container md-content" style={{ padding: '48px 24px 80px', maxWidth: 820 }}>
        <ReactMarkdown rehypePlugins={[rehypeSanitize]}>{source}</ReactMarkdown>
      </article>
      <div style={{ padding: '0 24px 24px' }}>
        <Footer />
      </div>
    </div>
  );
}
